export default __webpack_public_path__ + "static/media/tour-1.7249f01d.jpeg";